import styled from 'styled-components';
import { breakpoints, colors, fonts, pxToCssFont } from '@vfit/shared/themes';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  align-self: stretch;

  @media (min-width: ${breakpoints.tablet}) {
  }

  @media (min-width: ${breakpoints.desktop}) {
    width: 624px;
  }
`;
export const DivImgContainer = styled.div`
  display: flex;
  width: 84px;
  height: 84px;
  justify-content: center;
  align-items: center;
`;
export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  @media (min-width: ${breakpoints.tablet}) {
  }

  @media (min-width: ${breakpoints.desktop}) {
  }
`;

export const Paragraph = styled.p`
  margin: 0;
  font-weight: 400;
  color: ${colors.$262626};
`;

export const Title = styled(Paragraph)`
  color: var(--New-palette-Default-Monochrome-Monochrome5, #262626);
  text-align: center;
  font-family: ${fonts.vodafone};
  font-size: 36px;
  font-style: normal;
  font-weight: 800;
  line-height: 48px;
`;


export const Description = styled(Paragraph)`
  color: var(--New-palette-Default-Monochrome-Monochrome5, #262626);
  text-align: center;
  font-family: ${fonts.vodafone};
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;

  @media (min-width: ${breakpoints.tablet}) {
    ${pxToCssFont(20, 30)}
  }

  @media (min-width: ${breakpoints.desktop}) {
    ${pxToCssFont(20, 26)}
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;

  button {
    display: flex;
    width: 100%;
    height: 45px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    @media (min-width: ${breakpoints.desktop}) {
      width: 296px;
    }
  }

`;

